<template>
  <div aria-label="Chat suggestion" class="relative max-w-[220px] rounded-2xl bg-dark-bg-inset px-4 py-3 text-left shadow-xl" role="dialog">
    <button
      aria-label="Dismiss suggestion"
      class="absolute right-2 top-2 flex size-5 items-center justify-center rounded-full text-white/50 transition-colors hover:text-white"
      type="button"
      @click="$emit('dismiss')"
    >
      <X class="size-3.5" />
    </button>
    <p class="pr-5 font-Spectral text-[13px] leading-snug text-white/90">
      Have questions about this experience?
      <button class="inline text-left font-medium text-dark-fg-accent underline underline-offset-2 hover:text-white" type="button" @click="$emit('openChat')">Ask Wabunka AI Chat</button>
    </p>
    <!-- 下向き三角アロー（CSS triangle） -->
    <span aria-hidden="true" class="absolute -bottom-[7px] right-6 size-0 border-l-[7px] border-r-[7px] border-t-[7px] border-l-transparent border-r-transparent border-t-dark-bg-inset" />
  </div>
</template>

<script setup lang="ts">
import { X } from '@lucide/vue';

defineEmits<{
  dismiss: [];
  openChat: [];
}>();
</script>
